import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-8"
}
const _hoisted_3 = {
  key: 0,
  class: "text-caption text-grey py-6"
}
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = { class: "text-subtitle-2" }
const _hoisted_6 = {
  key: 0,
  class: "text-caption text-grey mt-1"
}
const _hoisted_7 = { class: "tp-phrase__body" }
const _hoisted_8 = { class: "tp-phrase__actions" }
const _hoisted_9 = { class: "text-caption text-grey-darken-1 mb-2" }
const _hoisted_10 = { class: "mt-2 font-weight-bold" }
const _hoisted_11 = { class: "mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[13] || (_cache[13] = _createElementVNode("div", null, [
        _createElementVNode("div", { class: "text-subtitle-1" }, "文例"),
        _createElementVNode("div", { class: "text-caption text-grey-darken-1" }, " レイアウトの項目ごとに文例を登録します。エディタでセルを選ぶと、その項目の文例が出ます。 ")
      ], -1)),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        class: "mr-2",
        variant: "outlined",
        loading: _ctx.exporting,
        onClick: _ctx.exportCsv
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createTextVNode("mdi-download", -1)
            ]))]),
            _: 1
          }),
          _cache[10] || (_cache[10] = _createTextVNode(" CSVをダウンロード ", -1))
        ]),
        _: 1
      }, 8, ["loading", "onClick"]),
      _createVNode(_component_v_btn, {
        variant: "outlined",
        color: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.importDialog = true))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createTextVNode("mdi-upload", -1)
            ]))]),
            _: 1
          }),
          _cache[12] || (_cache[12] = _createTextVNode(" CSVを取り込む ", -1))
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_row, {
      align: "center",
      class: "mt-2"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_select, {
              modelValue: _ctx.planType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.planType) = $event)),
              items: _ctx.createPlanTypeItems,
              label: "帳票種別",
              variant: "outlined",
              density: "compact",
              color: "primary",
              "hide-details": ""
            }, null, 8, ["modelValue", "items"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_select, {
              modelValue: _ctx.templateId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.templateId) = $event)),
              items: _ctx.templateItems,
              label: "レイアウト",
              variant: "outlined",
              density: "compact",
              color: "primary",
              "hide-details": "",
              "no-data-text": "この帳票種別のレイアウトがありません"
            }, null, 8, ["modelValue", "items"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.keyword,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.keyword) = $event)),
              label: "文例を検索",
              variant: "outlined",
              density: "compact",
              color: "primary",
              "hide-details": "",
              clearable: "",
              "prepend-inner-icon": "mdi-magnify",
              onKeyup: _withKeys(_ctx.load, ["enter"]),
              "onClick:clear": _ctx.clearKeyword
            }, null, 8, ["modelValue", "onKeyup", "onClick:clear"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "primary"
          })
        ]))
      : (_ctx.templateId)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.groups.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, " このレイアウトには文例グループが設定された項目がありません。レイアウトのセル設定で「文例グループ」を設定してください。 "))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group) => {
              return (_openBlock(), _createBlock(_component_v_card, {
                key: group.phraseKey,
                variant: "outlined",
                class: _normalizeClass(["mt-3 pa-3", { 'tp-phrase-group--focused': group.phraseKey === _ctx.initialPhraseKey }])
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(group.phraseKey), 1),
                    (!group.existsInLayout)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 0,
                          class: "ml-2",
                          size: "x-small",
                          variant: "flat",
                          color: "grey"
                        }, {
                          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                            _createTextVNode(" 現在のレイアウトに無い項目 ", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      variant: "text",
                      color: "primary",
                      disabled: !group.existsInLayout,
                      onClick: ($event: any) => (_ctx.openCreateDialog(group.phraseKey))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { start: "" }, {
                          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                            _createTextVNode("mdi-plus", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[16] || (_cache[16] = _createTextVNode(" 文例を追加 ", -1))
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ]),
                  (group.phrases.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 文例がありません。 "))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.phrases, (phrase, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: phrase.phraseId,
                      class: "tp-phrase mt-2"
                    }, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(phrase.body), 1),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_v_btn, {
                          size: "x-small",
                          variant: "text",
                          icon: "mdi-arrow-up",
                          disabled: index === 0 || _ctx.movingPhraseId !== null || _ctx.isFiltering,
                          title: _ctx.isFiltering ? '絞り込み中は並び替えできません' : '上へ',
                          onClick: ($event: any) => (_ctx.move(group, index, -1))
                        }, null, 8, ["disabled", "title", "onClick"]),
                        _createVNode(_component_v_btn, {
                          size: "x-small",
                          variant: "text",
                          icon: "mdi-arrow-down",
                          disabled: index === group.phrases.length - 1 || _ctx.movingPhraseId !== null || _ctx.isFiltering,
                          title: _ctx.isFiltering ? '絞り込み中は並び替えできません' : '下へ',
                          onClick: ($event: any) => (_ctx.move(group, index, 1))
                        }, null, 8, ["disabled", "title", "onClick"]),
                        _createVNode(_component_v_btn, {
                          size: "x-small",
                          variant: "text",
                          onClick: ($event: any) => (_ctx.openEditDialog(phrase))
                        }, {
                          default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                            _createTextVNode("編集", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_v_btn, {
                          size: "x-small",
                          variant: "text",
                          color: "error",
                          loading: _ctx.deletingPhraseId === phrase.phraseId,
                          onClick: ($event: any) => (_ctx.remove(phrase))
                        }, {
                          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                            _createTextVNode(" 削除 ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["loading", "onClick"])
                      ])
                    ]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["class"]))
            }), 128))
          ], 64))
        : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.editDialog,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editDialog) = $event)),
      "max-width": "640px",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.editingPhraseId ? "文例の編集" : "文例の追加"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, "項目: " + _toDisplayString(_ctx.editingPhraseKey), 1),
                _createVNode(_component_v_textarea, {
                  modelValue: _ctx.editingBody,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editingBody) = $event)),
                  rows: "5",
                  variant: "outlined",
                  density: "compact",
                  color: "primary",
                  counter: _ctx.phraseBodyMaxLength,
                  placeholder: "文例の本文を入力してください"
                }, null, 8, ["modelValue", "counter"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  disabled: _ctx.savingPhrase,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.editDialog = false))
                }, {
                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                    _createTextVNode(" キャンセル ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "flat",
                  loading: _ctx.savingPhrase,
                  disabled: !_ctx.isValidBody,
                  onClick: _ctx.savePhrase
                }, {
                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                    _createTextVNode(" 保存 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading", "disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.importDialog,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.importDialog) = $event)),
      "max-width": "640px",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                _createTextVNode("CSVを取り込む", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "text-body-2 mb-3" }, [
                  _createTextVNode(" 「CSVをダウンロード」で取得したファイルに文例を書き足してアップロードしてください。 "),
                  _createElementVNode("strong", null, "既存の文例は消えず、追記されます。")
                ], -1)),
                _createVNode(_component_v_file_input, {
                  modelValue: _ctx.importFile,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.importFile) = $event)),
                  label: "CSVファイル",
                  accept: ".csv,text/csv",
                  variant: "outlined",
                  density: "compact",
                  color: "primary",
                  "hide-details": "",
                  "prepend-icon": "",
                  "prepend-inner-icon": "mdi-paperclip"
                }, null, 8, ["modelValue"]),
                (_ctx.importResult)
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 0,
                      type: "info",
                      variant: "tonal",
                      density: "compact",
                      class: "mt-3"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(_ctx.importResult.imported) + "件を取り込みました。", 1),
                        (_ctx.importResult.skipped.length > 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_10, " 取り込めなかった行（" + _toDisplayString(_ctx.importResult.skipped.length) + "件） ", 1),
                              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "text-caption" }, " 行番号はCSVのレコード番号です（Excelの行番号と一致します）。 ", -1)),
                              _createElementVNode("ul", _hoisted_11, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.importResult.skipped, (skipped) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: skipped.row
                                  }, _toDisplayString(skipped.row) + "行目: " + _toDisplayString(skipped.reason), 1))
                                }), 128))
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  disabled: _ctx.importing,
                  onClick: _ctx.closeImportDialog
                }, {
                  default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                    _createTextVNode("閉じる", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "flat",
                  loading: _ctx.importing,
                  disabled: !_ctx.importFile,
                  onClick: _ctx.importCsv
                }, {
                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                    _createTextVNode(" 取り込む ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading", "disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}